import NothingToDisplay from './NothingToDisplay';

export default NothingToDisplay;
